var autoplaySlider = true;
var autoplayBtn, sliderNavBtns, sliderTimeout, liveregion;

function initialize(){
  autoplayBtn = document.getElementById('autoplay');
  sliderNavBtns = document.querySelectorAll('ul.slidenav > li > button'); //links

  liveregion = document.createElement('div');
  liveregion.setAttribute('aria-live', 'polite');
  liveregion.setAttribute('aria-atomic', 'true');
  liveregion.setAttribute('class', 'liveregion sr-only');
  document.querySelector('.slider').appendChild(liveregion);

  document.querySelectorAll('.slider .slider-img-container')[0].classList.add('visible');
  initClickEventOnSlider();
  noFocusOnInvisibleLinks();
  

  if(autoplayBtn){
    autoplayBtn.addEventListener("click", changeAutoplayBtnState, false);
    if (sliderNavBtns){
        sliderNavBtns.forEach( function(btn){ btn.addEventListener("click", changeSlide, false);  });    
    }
    startSliderTimeout();

  }
}

function initClickEventOnSlider(){
  var links = document.querySelectorAll('.slider .slider-img-container a');
  if(links){
    document.querySelectorAll('.slider-img-container').forEach( 
      function(item){ item.addEventListener('click', onSliderClick, false) 
    });
  }
}

function onSliderClick(e){
  var link = this.getElementsByTagName('a');
  if (e.target.classList.contains('slider-img-container') && link.length > 0){
    link[0].click();
  }
}

function noFocusOnInvisibleLinks(){
  var invisibleLinks = document.querySelectorAll('.slider .slider-img-container:not(.visible) a');
  if(invisibleLinks){
    invisibleLinks.forEach( function(item){ item.setAttribute('tabindex', '-1'); });
  }
}
function focusOnVisibleLinks(){
  var visibleLinks = document.querySelectorAll('.slider .slider-img-container.visible a');
  if(visibleLinks){
    visibleLinks.forEach( function(item){ item.setAttribute('tabindex', '0'); });
  }
}

function destroySlider(){
  clearTimeout(sliderTimeout);
}

function startSliderTimeout(){
  if (autoplaySlider){
    sliderTimeout = setTimeout(goToNextSlide, 10000);
  }
}

function changeSlide(){
    clearTimeout(sliderTimeout);

    document.querySelector('.slider .slider-img-container.visible').classList.remove("visible");
    document.querySelectorAll('.slider .slider-img-container')[this.dataset.slide].classList.add('visible');
    noFocusOnInvisibleLinks();
    focusOnVisibleLinks();

    document.querySelector('.slider .slider-img-container.visible').focus();

    document.querySelector('ul.slidenav button.current').classList.remove("current");
    var srText = document.getElementById('current');
    this.classList.add('current');
    this.appendChild(srText);

    document.querySelector('.slider .liveregion').textContent = `Element ${this.dataset.slide * 1 + 1} von ${document.querySelectorAll('.slider .slider-img-container').length}`;

    startSliderTimeout();
}

function goToNextSlide() {
    var visibleSlide = document.querySelector('ul.slidenav button.current').dataset.slide;
    
    var nextSlide = visibleSlide*1 + 1;
    if(nextSlide > document.querySelectorAll('.slider .slider-img-container').length -1 ){
      nextSlide = 0;
    }

    document.querySelector('.slider .slider-img-container.visible').classList.remove("visible");
    document.querySelectorAll('.slider .slider-img-container')[nextSlide].classList.add('visible');
    noFocusOnInvisibleLinks();
    focusOnVisibleLinks();

    document.querySelector('ul.slidenav button.current').classList.remove("current");
    document.querySelectorAll('ul.slidenav button')[nextSlide].classList.add("current");
    var srText = document.getElementById('current');
    document.querySelector('ul.slidenav button.current').appendChild(srText);

    document.querySelector('.slider .liveregion').textContent = `Element ${ nextSlide*1 + 1} von ${document.querySelectorAll('.slider .slider-img-container').length}`;

    startSliderTimeout();  
}


function changeAutoplayBtnState(){
  if(autoplayBtn.getAttribute("aria-pressed") == "true"){
    autoplayBtn.setAttribute ("aria-pressed", "false");
    autoplayBtn.querySelector('span').textContent = 'Pause';
    autoplaySlider = true;
    goToNextSlide();
  }else{
    autoplayBtn.setAttribute ("aria-pressed", "true");
    autoplayBtn.querySelector('span').textContent  = 'Play';
    autoplaySlider = false;
    clearTimeout(sliderTimeout);
  }
}


export default {
  init: function() { initialize() },
  destroy: function(){ destroySlider()}
}




// WEBPACK FOOTER //
// ./src/shared/sliderHelper.js